import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertCircle, Camera } from 'lucide-react';
import ProjectSummary from './ProjectSummary';

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

export default function SnapshotViewer() {
  const { snapshotId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      setError('Geçersiz snapshot bağlantısı (token eksik)');
      setLoading(false);
      return;
    }
    fetchSnapshot();
  }, [snapshotId, token]);

  const fetchSnapshot = async () => {
    try {
      const r = await axios.get(`${API}/snapshots/${snapshotId}?token=${encodeURIComponent(token)}`);
      setSnapshot(r.data);
    } catch (e) {
      setError(e?.response?.data?.detail || 'Snapshot yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-cyan-500"></div>
      </div>
    );
  }

  if (error || !snapshot) {
    return (
      <div className="flex flex-col items-center justify-center h-screen p-6">
        <AlertCircle className="w-16 h-16 text-red-500 mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Snapshot Görüntülenemedi</h1>
        <p className="text-gray-600">{error}</p>
      </div>
    );
  }

  // Snapshot içindeki summary verisini ProjectSummary'ye geçir, read-only modda
  const summaryData = {
    ...snapshot.summary,
    createdAt: snapshot.createdAt,
    createdByName: snapshot.createdByName,
  };

  return (
    <div>
      {/* Read-only snapshot banner */}
      <div className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white py-2 px-4 flex items-center justify-center gap-2 text-sm">
        <Camera className="w-4 h-4" />
        <span>📸 Bu sayfa bir <strong>snapshot</strong>'tır — {new Date(snapshot.createdAt).toLocaleString('tr-TR')} tarihinde alınmış arşiv görüntüsüdür.</span>
      </div>
      <ProjectSummary snapshotData={summaryData} />
    </div>
  );
}
